import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';
import classNames from 'classnames';

export function LanguageSwitch() {
  const { i18n } = useTranslation('anfrage-sitaram');
  const location = useLocation();

  const pathWithoutLanguage = location.pathname.replace(/^\/(de|en)/, '');

  return (
    <nav aria-label="Language" className="print:hidden">
      <div className="inline-flex h-9 items-center overflow-hidden rounded-full border border-slate-200 bg-white text-xs font-medium uppercase tracking-[0.12em] shadow-sm">
        {(['de', 'en'] as const).map((language) => (
          <Link
            key={language}
            to={{
              pathname: `/${language}${pathWithoutLanguage}`,
              search: location.search,
            }}
            onClick={() => i18n.changeLanguage(language)}
            className={classNames(
              'flex h-full items-center px-3 transition',
              i18n.language === language
                ? 'bg-brand-green-700 text-white'
                : 'text-slate-700 hover:bg-slate-50'
            )}
          >
            {language}
          </Link>
        ))}
      </div>
    </nav>
  );
}

export default LanguageSwitch;
